<template>
  <div>
    <div class="navbar-wrapper">
      <Navbar
        minimal
        is-webshop
        hide-cart
        hide-shadow
        hide-wallet
        :wallet-amount="spaazaUser.amount"
        :cart="cart"
        :logo-link="logoLink"
        :login-link="loginLink"
        :account-link="accountLink"
        :menu-items="menuItems"
        :language-dropdown-settings="languageDropdownSettings"
        :country-dropdown-settings="countryDropdownSettings"
        :account-dropdown-settings="accountDropdownSettings"
        :user="user"
        :user-authenticated="isAuthenticated"
        @logout="logout"
      />
    </div>
    <div class="no-padding-container container">
      <div
        class="content-container flex flex-col md:pt-6 md:pb-40"
      >
        <div
          class="left-flex flex-1"
        >
          <WebshopCheckoutHeader :active-index="activeIndex" />
          <div class="pt-9 lg:pt-10">
            <nuxt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authenticated } from '@/mixins/layouts'
import spaazaMixin from '@/mixins/spaaza'
import webshopMixin from '@/mixins/webshop'
import Navbar from '@/components/Navbar/Navbar'
import WebshopCheckoutHeader from '@/components/Webshop/WebshopCheckoutHeader'

export default {
  name: 'LayoutWebshopConfirmation',
  middleware: 'homepage',
  components: { Navbar, WebshopCheckoutHeader },
  mixins: [authenticated, spaazaMixin, webshopMixin],
  async fetch () {
    try {
      await Promise.all([
        this.getSpaazaUser(),
        this.getSpaazaWallet(),
        this.getAndSetShippingDetails()
      ])
    } catch (error) {
      this.$ota.general.logError(error)
    }
  },
  computed: {
    activeIndex () {
      return 2
    }
  },
  head () {
    return {
      script: [
        {
          hid: 'webshop-gtm',
          innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-M73VTJX');`,
          type: 'text/javascript'
        }
      ],
      __dangerouslyDisableSanitizersByTagID: {
        'webshop-gtm': ['innerHTML']
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.h-auto {
  height: auto;
}

@screen lg {
  .content-container {
    @apply flex-row;

    .left-flex {
      @apply pt-1 mr-10;
      max-width: 64.8rem;
    }
  }
}
</style>
